<template>
  <div>
    <div class="query-select">
      <el-form :inline="true" :model="queryParams" class="user-search">
        <el-form-item label="姓名：">
          <el-input
            size="small"
            v-model="queryParams.name"
            placeholder="输入姓名"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          type="primary"
          icon="el-icon-search"
          plain
          size="small"
          round
          @click="getTableList"
          >查询</el-button
        >
        <el-button
          type="warning"
          icon="el-icon-refresh-left"
          plain
          size="small"
          round
          @click="resetSelect"
          >重置</el-button
        >
        <el-button
          type="success"
          icon="el-icon-download"
          plain
          size="small"
          round
          @click="downloadExcel"
          >导出</el-button
        >
      </div>
    </div>
    <!--列表-->
    <div class="main-table">
      <el-table
        header-cell-class-name="table-header"
        border
        stripe
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="拼命加载中"
        style="width: 85vw"
      >
        <el-table-column align="center" type="index" width="60">
        </el-table-column>
        <el-table-column
          align="center"
          prop="name"
          label="姓名"
          width="180"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="wechatNo"
          label="微信号"
          width="180"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="inviteCode"
          label="邀请码"
          width="180"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="手机号"
          width="180"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          align="center"
          prop="company"
          label="单位	"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="industry"
          label="行业"
          width="200"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="job"
          label="职业	"
          width="200"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="classTime"
          label="开班时间"
          width="200"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="报名时间"
          width="180"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="queryParams.pageNum"
        :page-size="10"
        layout="total, prev, pager, next"
        :total="totals"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";
import { getExamAll } from "@/api/exam";
import download from "@/utils/download";
// import { tableGet, dataUpload, dataDelete } from "../../api/student";
import { tableGet, dataExport } from "@/api/sign";
import { getMinTime } from "@/utils/util";
import { getExamLabel } from "@/utils/dict.js";

export default {
  data() {
    return {
      values: "",
      totals: 0,
      loading: false, //是显示加载
      listData: [],
      uploadVisible: false,
      isUploading: false,
      fileList: [],
      dateRange: [],
      classData: null,
      // 分页参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: ""
      }
    };
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getTableList();
  },
  mounted() {},
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getExamLabel,
    getMinTime,
    async downloadTemp() {
      const res =
        process.env.NODE_ENV === "production"
          ? "./static/考生模版.xlsx"
          : "/static/考生模版.xlsx";
      window.open(res);
    },
    async downloadExcel() {
      const res = await dataExport();
      download.excel(res.data, "报名信息.xlsx");
    },
    resetSelect() {
      this.queryParams.name = "";
      this.getTableList();
    },

    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getTableList();
    },
    // 获取表格数据
    async getTableList() {
      this.loading = true;
      // const params = tansParams(this.queryParams);

      const res = await tableGet(this.queryParams);
      let result = res.data;
      if (result.code === 200) {
        this.loading = false;
        this.listData = result.data.list;
        this.totals = result.data.total;
      } else {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/views/Sign/index.vue